export default __webpack_public_path__ + "static/media/OP.c458bc94.JPG";